import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

@Component({
    selector: 'app-not-found',
    template: `
  <div>
    <h2>
      <p style="margin-left: 20px">404 - Page not found</p>
    </h2>
    <br>
    <p style="margin-left: 20px">The page {{router.url}} was not found.</p>
  </div>
    `,
    standalone: false
})
export class NotFoundComponent implements OnInit {
  path: string

  constructor(public router: Router) {}

  ngOnInit() {
    // on init
  }
}
